export const PATTERNS = {
    PATTERN_001: new RegExp('^[0-9a-zA-Z]*$'), // Access half width only
    PATTERN_002: new RegExp('^[0-9a-zA-Z-]*$'), // Access half width and '-' character
    PATTERN_003: new RegExp('^[0-9a-zA-Z.,+]*$'), // Access half width and '. , +' character
    PATTERN_004: new RegExp('^[0-9e.,+]*$'), // Access half width number and '. , +' character
    PATTERN_005: new RegExp('^[0-9]*$') // Access half width number and '. , +' character
}

export const SETTING_KEYS = {
    ZIPCODE: 'zipcode',
    BUSSINESS_NAME: 'bussiness_name',
    TAX_RATE: 'tax_rate'
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/system.const.ts